import React from 'react';
import { Dropdown, TextField, ITextFieldStyles } from '@fluentui/react';
import { glyphList } from './glyphList';
import { placementList } from './placementList';
import { IHotspot } from './hotspot-panel';

declare let _TL_: any;

interface IProps {
  i18n: any;
  hotspot: IHotspot;
  hotspots: IHotspot[];
  index: number;
  enableHotSpotPlacement: boolean;
  showHotspotCount: boolean;

  handleChangeTextField: (index: number, field: string, value: string) => void
  handleChangeGlyph: (index: number, value: string) => void;
  handleChangePlacement: (index: number, value: string) => void;
}

function remainingWarning(text: string, limit: number, i18n: any): string {
  if (text.length > limit) {
    return i18n.getString(_TL_('Exceeded by {{count}} characters'), { count: text.length - limit });
  }
  return `${limit - text.length} ${i18n.getString(_TL_('characters remaining'))}`;
}

function getErrorMessage(text: string, limit: number, i18n: any): string {
  if (text.length > limit) {
    return i18n.getString(_TL_('Field should not exceed {{count}} characters'), { count: text.length - limit });
  }

  return '';
}

function getPlacementMessage(placement: string, hotspots: IHotspot[], i18n: any): string {
  const placements = hotspots.map(i => i.placement).filter(i => !!i);
  if (new Set(placements).size !== placements.length) {
    return i18n.getString(_TL_('Duplicate placement'));
  }

  return '';
}

export class Hotspot extends React.Component<IProps> {
  handleChangeTitle = (field: string, _, value) => {
    const { index } = this.props;

    this.props.handleChangeTextField(index, field, value as string);
  };

  handleChangeGlyph = (_, item) => {
    const { index } = this.props;

    this.props.handleChangeGlyph(index, item.key);
  };

  handleChangePlacement = (_, item) => {
    const { index } = this.props;

    this.props.handleChangePlacement(index, item.key);
  };

  render() {
    const {
      i18n, hotspot, hotspots, index, showHotspotCount = false,
    } = this.props;

    const {
      title, desc, actionText, uri, glyph, placement,
    } = hotspot;

    const textFiledStyles: Partial<ITextFieldStyles> = {
      description: {
        width: '100%',
        display: 'inline-block',
        textAlign: 'right',
        fontSize: 14,
      },
    };

    return (
      <div>
        { showHotspotCount && (<h6>{`${i18n.getString(_TL_('Hotspot'))} ${index + 1}`}</h6>) }
        <Dropdown
          label={i18n.getString(_TL_('Icon'))}
          required
          onChange={this.handleChangeGlyph}
          selectedKey={glyph}
          options={glyphList}
        />
        <TextField
          required
          value={title}
          className="hotspot-title"
          onChange={this.handleChangeTitle.bind(this, 'title')}
          errorMessage={getErrorMessage(title, 108, i18n)}
          description={remainingWarning(title, 108, i18n)}
          label={i18n.getString(_TL_('Title'))}
          styles={textFiledStyles}
        />
        <TextField
          value={desc}
          className="hotspot-desc"
          onChange={this.handleChangeTitle.bind(this, 'desc')}
          errorMessage={getErrorMessage(desc, 200, i18n)}
          description={remainingWarning(desc, 200, i18n)}
          label={i18n.getString(_TL_('Description'))}
          styles={textFiledStyles}
        />
        <TextField
          required
          className="hotspot-actionText"
          value={actionText}
          onChange={this.handleChangeTitle.bind(this, 'actionText')}
          errorMessage={getErrorMessage(actionText, 54, i18n)}
          description={remainingWarning(actionText, 54, i18n)}
          label={i18n.getString(_TL_('Action Text'))}
          styles={textFiledStyles}
        />
        <TextField
          required
          className="hotspot-uri"
          value={uri}
          onChange={this.handleChangeTitle.bind(this, 'uri')}
          errorMessage={getErrorMessage(uri, 400, i18n)}
          description={remainingWarning(uri, 400, i18n)}
          label={i18n.getString(_TL_('URI'))}
          styles={textFiledStyles}
        />
        {this.props.enableHotSpotPlacement && (
        <Dropdown
          label={i18n.getString(_TL_('Placement'))}
          className="hotspot-placement"
          required
          onChange={this.handleChangePlacement}
          errorMessage={getPlacementMessage(placement, hotspots, i18n)}
          selectedKey={placement}
          options={placementList}
        />
        )}

      </div>
    );
  }
}

